module.exports = __webpack_public_path__ + "img/64.87282fba.jpg";